import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const TipsPage = lazy(() => import('../pages/tips/page'));
const NewCasePage = lazy(() => import('../pages/cases/new/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const LeoPortalPage = lazy(() => import('../pages/leo-portal/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/cases/new',
    element: <NewCasePage />,
  },
  {
    path: '/tips',
    element: <TipsPage />,
  },
  {
    path: '/leo-portal',
    element: <LeoPortalPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;